import React from 'react';
import { withStyles } from 'material-ui/styles';
import Grid from 'material-ui/Grid';
import UIButton from '../../../core/ui/button.js';

const styles = theme => ({
  root: {
  },
  option : {
    padding: 2,
    border: '1px solid #808080',   
    margin: 5,
  },
  option_selected : {
    padding: 2,
    border: '1px solid #ff5252',   
    margin: 5,
  },
  option_text : {
    fontSize: 12,
  },
  question : {
    fontSize: 18,
    textAlign: 'center',
  },
  intro : {
    marginTop: 5,
    fontSize: 10,
    color: '#808080',
    textAlign: 'justify',
  },
});

class Survey001 extends React.Component {
  constructor(){
    super();

    this.state = {
      selected : null,
    };
  }

  onClick(data){
    this.setState({selected : data});
    this.props.onClickResponse(data);
  }

  onRespond(){
    this.props.onRespond(this.state);
  }

  render() {
    const classes = this.props.classes;
    var key = 0;
    return (
      <Grid container className={classes.root} spacing={8}>
        <Grid item xs={12}>
          <div className={classes.question}>Que opci&oacute;n te parece mejor?</div>
        </Grid>      
        <Grid item xs={6}>
          <div className={classes.option_text}>Después</div>
          <div className={(this.state.selected === 'A') ? classes.option_selected : classes.option} onClick={this.onClick.bind(this, 'A')}>
            <img src='./res/survey/001a.jpeg' width='100%'/>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div className={classes.option_text}>Antes</div>
          <div className={(this.state.selected === 'B') ? classes.option_selected : classes.option} onClick={this.onClick.bind(this, 'B')}>
            <img src='./res/survey/001b.jpeg' width='100%'/>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className={classes.intro}>¿En dónde te parece más conveniente que se ubique el cuadrito de información, antes del resultado o después?</div>
        </Grid>      
        <Grid item xs={12} style={{textAlign : 'right'}}>
          <UIButton disabled={(this.state.selected === null) ? true : false} icon='ok' render='icon' onClick={this.onRespond.bind(this)} color='primary'/>
        </Grid>      
      </Grid>
    );
  }              

}

export default withStyles(styles)(Survey001);


// WEBPACK FOOTER //
// ./src/search/components/surveys/survey001.js